import { render, staticRenderFns } from "./Para_Info.vue?vue&type=template&id=b4af4a1c&"
import script from "./Para_Info.vue?vue&type=script&lang=js&"
export * from "./Para_Info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports